export default class JPlusSignup {
	static init() {
		const jPlusForm = document.getElementById('jplus-form');
		const jPlusButton = document.querySelector('.js-jplus-signup');

		if (!jPlusForm) {
			return false;
		}

		jPlusButton.addEventListener('click', (e) => {
			e.preventDefault();

			const emailInput = document.getElementById('jplus-email');
			const email = emailInput.value;
			const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

			if (email !== '' && !emailRegex.test(email)) {
				alert('Den adress du angivit har ett ogiltigt format.');
				return;
			}

			const baseUrl = jPlusForm.dataset.action;
			const continueUrl = window.location.href + '?reauth=true';
			const params = new URLSearchParams();

			if (email) {
				params.append('email', email);
			}

			params.append('continue_url', continueUrl);

			const newActionUrl = `${baseUrl}?${params.toString()}`;

			jPlusForm.setAttribute('action', newActionUrl);

			window.location.href = newActionUrl;
		});
	}
}
